import { useMemo } from 'react';
import { getDateAsYYYYMMDD } from 'libs/end-to-end/src/dates';
import { ObservationLocationType } from 'libs/end-to-end/src/observation-upload-type';
import { HiringCopilotRequest } from 'libs/end-to-end/src/custom-viz/HiringCopilotTypes';

export const useHiringCopilotCurrentCustomVizRequestToExecute = ({
  selectedStartDate,
  selectedEndDate,
  selectedDepartments,
  selectedRoles,
  selectedLocations,
  organizationId,
  observation,
  selectedSlateIds,
}: {
  selectedStartDate: Date | undefined;
  selectedEndDate: Date | undefined;
  selectedDepartments: string[];
  selectedRoles: string[];
  selectedLocations: string[];
  organizationId: string;
  observation: ObservationLocationType;
  selectedSlateIds: string[];
}): HiringCopilotRequest | null => {
  return useMemo(() => {
    if (!selectedEndDate || !selectedStartDate) {
      return null;
    }

    return {
      customVizId: 'hiringCopilot',
      inputs: {
        dropdowns: {
          department: selectedDepartments,
          job_title: selectedRoles,
          location: selectedLocations,
          start_date: [getDateAsYYYYMMDD(selectedStartDate)],
          end_date: [getDateAsYYYYMMDD(selectedEndDate)],
        },
        extras: {
          your_list_subject_ids: selectedSlateIds,
        },
      },
      organizationId,
      observationLocationType: observation,
    };
  }, [
    selectedEndDate,
    selectedStartDate,
    selectedDepartments,
    selectedRoles,
    selectedLocations,
    selectedSlateIds,
    organizationId,
    observation,
  ]);
};
